import { render, staticRenderFns } from "./DefectModal.vue?vue&type=template&id=e7461746&scoped=true"
import script from "./DefectModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefectModal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7461746",
  null
  
)

export default component.exports